import { BaseHubSpotFormModel } from '@/models';
import CONFIG from 'Config';

export class FormModelSubscribeNewsletter extends BaseHubSpotFormModel {
  getFields() {
    return {
      email: '',
    };
  }

  get hubSpotFormId() {
    return CONFIG.hubspotFormIds.subscribeNewsletter;
  }

  get hubSpotFormName() {
    return 'Subscribe newsletter';
  }
}
